export const CORE_INPUT_TEXT_DISPLAY_NAME = "CoreInputText";
